import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-mirror",
  "use": "svg_i-mirror-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\" id=\"svg_i-mirror\"><path d=\"M7.87 0v2.855H0v18.092h7.87v2.855h2.05v-2.855h7.87V2.855H9.92V0H7.87ZM2.05 18.862h5.82V4.94H2.05v13.923Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol